export default {"src":"/_next/static/image/public/images/ic_big_add_member_success.1dfecfe1885e3656434776ae9c8293ab.svg","height":167,"width":168};